import { Entity, GroupEntity } from '@vincerosoft/assessfluence-types';

type AccountWithSeatLimit = Entity | GroupEntity;

export const withDefaultSeatLimit = <T extends AccountWithSeatLimit>(
  account: T
): T & { seats: NonNullable<Entity['seats']> } => ({
  ...account,
  seats: account.seats?.type
    ? account.seats
    : {
        ...(account.seats ?? {}),
        type: 'capped',
        limit: 0
      }
});
